import { useState } from 'react';
import { arrowTopRightWhite } from '../../../../../../assets/hostedassets';
import styles from './CaseDetailsDrawer.module.scss';
import { DOCUMENT_COLLAPSE_LIMIT, moreDocumentsLabel, SEE_LESS_LABEL } from './constants';
import { CaseDocumentLinksProps } from './types';

const CaseDocumentLinks = ({ documents, onDocumentClick }: CaseDocumentLinksProps) => {
    const [expanded, setExpanded] = useState(false);
    const hiddenCount = documents.length - DOCUMENT_COLLAPSE_LIMIT;
    const collapsed = !expanded && hiddenCount > 0;
    const visible = collapsed ? documents.slice(0, DOCUMENT_COLLAPSE_LIMIT) : documents;

    return (
        <span className={styles.DocumentLinks}>
            {visible.map((doc, index) => (
                <span className={styles.DocumentLinkRow} key={doc.docId}>
                    <button type="button" className={styles.DocumentLink} onClick={() => onDocumentClick?.(doc.docId)}>
                        <span className={styles.DocumentIcon}>
                            <img src={arrowTopRightWhite} alt="" aria-hidden="true" />
                        </span>
                        {doc.label}
                    </button>
                    {hiddenCount > 0 && index === visible.length - 1 && (
                        <button type="button" className={styles.MoreToggle} onClick={() => setExpanded((previous) => !previous)}>
                            {collapsed ? moreDocumentsLabel(hiddenCount) : SEE_LESS_LABEL}
                        </button>
                    )}
                </span>
            ))}
        </span>
    );
};

export default CaseDocumentLinks;
